import * as React from 'react';

export const badge = (kind: 'muted' | 'info' | 'warn' | 'danger', text: string) => {
  const cls =
    kind === 'danger'
      ? 'cpBadge cpBadge--danger'
      : kind === 'warn'
      ? 'cpBadge cpBadge--warn'
      : kind === 'info'
      ? 'cpBadge cpBadge--info'
      : 'cpBadge cpBadge--muted';

  return <span className={cls}>{text}</span>;
};

export const renderEnumOptions = (opts: string[], max = 6) => {
  const clean = (opts || []).map(x => String(x || '').trim()).filter(Boolean);
  if (!clean.length) return null;

  const shown = clean.slice(0, max);
  const rest = clean.length - shown.length;

  return (
    <div className="text-muted mt-1" style={{ fontSize: 13, lineHeight: 1.25, wordBreak: 'break-word' }}>
      <b>Options:</b> {shown.join(', ')}
      {rest > 0 ? ` (+${rest} more)` : ''}
    </div>
  );
};
